import classNames from "classnames";
import { FC } from "react";
import { SingleValueProps } from "react-select";
import { createComponentStyleHook } from "capitalrx-components-2.0/lib/tokens";
import { OptionItem } from "../../OptionItem";
import { getStyleModeSafeProps } from "../../../utils/getStyleModeSafeProps";
import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

const useResolvedDropdownSingleValueStyles = createComponentStyleHook<SingleValueProps<OptionItem | null>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "dropdown_single_value",
});

/**
 * A selected single value within the ValueContainer.
 */
export const SingleValue: FC<SingleValueProps<OptionItem | null>> = (props) => {
  const { children, innerProps } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedDropdownSingleValueStyles(getStyleModeSafeProps(props));

  const singleValueClassName = classNames(styles.SingleValue, "single-value");

  return (
    <StyleModeBoundary mode={mode}>
      <div {...innerProps} className={singleValueClassName}>
        {children}
      </div>
    </StyleModeBoundary>
  );
};
